'use client'

import { useContext } from 'react'

import { InfoBanner, Text } from '@vinted/web-ui'

import { GetShippingLabelContext } from '@marketplace-web/shipping-services-provider/shipping-services-provider-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { GenerateLabelModal } from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { clickEvent } from '@marketplace-web/order-details-fulfillment/order-details-fulfillment-data'
import { useConversationSidebarContext } from '@marketplace-web/messaging/conversation-providers-feature'

type Props = {
  transactionId?: number
}

const DialogInfoBanner = ({ transactionId }: Props) => {
  const {
    state: {
      labelOptions: { labelOptions, labelOptionsRewrite },
      activeModal: { setActiveModal },
    },
  } = useContext(GetShippingLabelContext)
  const { openSidebar } = useConversationSidebarContext()

  const { track } = useTracking()

  const labelOptionsData = labelOptionsRewrite || labelOptions

  if (!labelOptionsData?.infoBannerText) return null

  const trackCangeDeliveryOptionClick = () => {
    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        target: 'request_carrier_change',
        screen: 'get_shipping_label',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  const handleInfoBannerLinkClick = (event: React.MouseEvent<Element, MouseEvent>) => {
    event.preventDefault()

    setActiveModal(GenerateLabelModal.None)
    openSidebar()
  }

  const handleCangeDeliveryOptionClick = (event: React.MouseEvent<Element, MouseEvent>) => {
    event.preventDefault()

    trackCangeDeliveryOptionClick()

    setActiveModal(GenerateLabelModal.CarrierChangeModal)
  }

  const handleClick = (event: React.MouseEvent) => {
    const targetElement = event.target as HTMLElement

    if (targetElement.classList.contains('react-change-delivery-option-link')) {
      handleCangeDeliveryOptionClick(event)
    }
    if (targetElement.classList.contains('react-order-details-link')) {
      handleInfoBannerLinkClick(event)
    }
  }

  const getInfoBannerType = () => (labelOptionsData?.infoBannerType === 'info' ? 'info' : 'warning')

  return (
    <InfoBanner
      body={
        <span role="none" onClick={handleClick}>
          <Text
            text={labelOptionsData.infoBannerText}
            html
            testId="generate-label-modal-info-banner-text"
            as="span"
          />
        </span>
      }
      type={getInfoBannerType()}
    />
  )
}

export default DialogInfoBanner
